import { createPublicClient, http, parseAbi } from "viem";
import { sepolia } from "viem/chains";
import { getContractAddress } from "./contracts";
import { getChainConfig } from "../config/networks";

const USDC_ABI = parseAbi([
  "function balanceOf(address owner) view returns (uint256)",
  "function decimals() view returns (uint8)",
]);

export const getUSDCBalance = async (address: `0x${string}`) => {
  try {
    // get the chain config for the current network
    const chain = getChainConfig();

    const client = createPublicClient({
      chain: chain,
      transport: http(chain.rpcUrls[0]),
    });

    const usdcAddress = await getContractAddress("USDC");
    if (!usdcAddress) {
      throw new Error("USDC contract address not found");
    }

    const balance = await client.readContract({
      address: usdcAddress as `0x${string}`,
      abi: USDC_ABI,
      functionName: "balanceOf",
      args: [address],
    });

    return balance;
  } catch (error) {
    console.error("Error getting USDC balance:", error);
    throw error;
  }
};
